/* Kick Frame — winkelwagen-lade als matchday-ticket: posters genummerd als line-up,
   onderaan een crème ticketstrook met scheurrand, gaatjes, totaal, afrekenknop en barcode.
   De lade zelf komt uit kickframe.js; dit script voegt alleen stijl en twee kleine elementen toe. */
(function () {
  var css = ''
    + '.cart-drawer-header h2::before{content:"MATCHDAY \\00B7  KICK FRAME";display:block;margin-bottom:.45rem;'
    + 'font:600 .68rem/1 Inter,system-ui,sans-serif;letter-spacing:.2em;color:var(--gold,#d6b25e)}'
    + '.cart-drawer-lines{counter-reset:kfline}'
    + '.cart-line{counter-increment:kfline;position:relative;padding-left:2.3rem}'
    + '.cart-line::before{content:counter(kfline,decimal-leading-zero);position:absolute;left:0;top:.15rem;'
    + 'font:600 1.05rem/1 Fraunces,Georgia,serif;color:var(--gold,#d6b25e)}'
    + '.cart-drawer-footer{margin:0 .9rem .9rem;border:1px solid rgba(214,178,94,.38);border-radius:14px;'
    + 'background:linear-gradient(160deg,#183327 0%,#10231a 100%);color:#f3eee1;'
    + 'position:relative;overflow:visible;padding:1.35rem 1.25rem 1.1rem;box-shadow:0 18px 40px -22px rgba(0,0,0,.8)}'
    + '.cart-drawer-footer .cart-drawer-subtotal{color:#f3eee1}'
    + '.kf-tear{position:relative;height:0;margin:.15rem -1.25rem .1rem;border-top:2px dashed rgba(214,178,94,.45)}'
    + '.kf-tear::before,.kf-tear::after{content:"";position:absolute;top:-12px;width:22px;height:22px;border-radius:50%;'
    + 'background:var(--kf-drawer-bg,#0c1511);border:1px solid rgba(214,178,94,.38)}'
    + '.kf-tear::before{left:-12px;clip-path:inset(0 0 0 50%)}.kf-tear::after{right:-12px;clip-path:inset(0 50% 0 0)}'
    + '.kf-ticket-meta{display:flex;justify-content:space-between;gap:.5rem;font:600 .62rem/1 Inter,system-ui,sans-serif;'
    + 'letter-spacing:.16em;text-transform:uppercase;color:var(--gold,#d6b25e)}'
    + '.kf-barcode{height:30px;opacity:.55;background:repeating-linear-gradient(90deg,#f3eee1 0 2px,transparent 2px 4px,'
    + '#f3eee1 4px 7px,transparent 7px 9px,#f3eee1 9px 10px,transparent 10px 13px,#f3eee1 13px 16px,transparent 16px 17px)}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function decorate(drawer) {
    var h2 = drawer.querySelector('.cart-drawer-header h2');
    if (h2 && h2.textContent !== 'Your order') h2.textContent = 'Your order';
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    if (!footer || footer.querySelector('.kf-tear')) return;
    var btn = footer.querySelector('.button');
    if (!btn) return;   // lege wagen: geen ticketstrook
    // gaatjes in de kleur van de lade zelf, zodat ze er echt "uitgeknipt" uitzien
    drawer.style.setProperty('--kf-drawer-bg', getComputedStyle(drawer).backgroundColor);
    var tear = document.createElement('div'); tear.className = 'kf-tear'; tear.setAttribute('aria-hidden', 'true');
    footer.insertBefore(tear, btn);
    var meta = document.createElement('div'); meta.className = 'kf-ticket-meta'; meta.setAttribute('aria-hidden', 'true');
    meta.innerHTML = '<span>Admit one</span><span>Free shipping · 2-4 days</span>';
    var bar = document.createElement('div'); bar.className = 'kf-barcode'; bar.setAttribute('aria-hidden', 'true');
    footer.appendChild(meta); footer.appendChild(bar);
  }

  new MutationObserver(function () {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer && !drawer.dataset.kfTicket) {
      drawer.dataset.kfTicket = '1';
      var footer = drawer.querySelector('[data-cart-drawer-footer]');
      new MutationObserver(function () { decorate(drawer); }).observe(footer, { childList: true });
      decorate(drawer);
    }
  }).observe(document.body, { childList: true });
})();
